module.exports = __webpack_public_path__ + "static/media/linkedin.be97554a.svg";